import { benoitApi } from 'apis';
import { useMutation } from 'react-query';

export function useArchiveBoardCard() {
    return useMutation((card)=> benoitApi.archiveBoardCard(card.id));
}
